<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre8">Zweite Szene</h3>
<p class="stage">Eine Galerie im Schlosse des Markgrafen von
Saluzza. Vor den Fenstern breiten sich der Spiegel und die Gelände
eines oberitalienischen Sees aus.</p>
<p class="stage">Graf Eberhard, über die Fünfzig hinaus; Graf
Heinz, sein Sohn, fünfundzwanzig Jahre alt; Die Baronin, schlank,
dreißigjährig: diese alle in Reitanzügen. Der Haushofmeister, der
Schloßpropst, beide sich dem vierzigsten Jahre nähernd.</p>
<p class="calibre1"><span class="speaker">Graf Eberhard</span>. Demnach ist also
noch immer keine irgendwie erhebliche Änderung eingetreten,
Haushofmeister?</p>
<p class="calibre1"><span class="speaker">Haushofmeister</span>. Nein. Er wohnt in
einem schlechten Domestikengelaß. Was die Köche zubereiten,
verschmäht er. Er röstet sich selbst Kastanien und schlingt sie
noch mit der glühenden Asche hinunter. Er trinkt Wasser oder den
allerminderwertigsten Desenzano, der zu bekommen ist. Wo er grade
geht oder steht, ißt er sein Schwarzbrot und seinen Kuhkäse oder
Speck aus der freien Faust. In wärmeren Nächten schläft er zwischen
dem Schwarzwild, höher hinauf in den Wäldern. Er verkriecht sich
ins trockene Laub an den Futterstellen oder auf einem Heuboden,
wenn's hochkommt, wo ihm dann gelegentlich, wenn ich die Wahrheit
sagen soll, eine beliebige Bauernmagd Gesellschaft leistet. So ist
unser Herr: beinahe haben wir keinen.</p>
<p class="calibre1"><span class="speaker">Graf Eberhard</span>. Was meint Ihr dazu,
Propst?</p>
<p class="calibre1"><span class="speaker">Der Schloßpropst</span>. Es ist undankbar,
über die Eigentümlichkeiten regierender Herren sich Gedanken zu
machen.</p>
<p class="calibre1"><span class="speaker">Graf Eberhard</span>. Mein Neffe Ulrich
muß heiraten!</p>
<p class="calibre1"><span class="speaker">Die Baronin</span>, <span class="regie">höhnisch.</span> Gebt ihm eine Frau, gebt ihm eine Frau,
sonst kommt er ins Narrenhaus.</p>
<p class="calibre1"><span class="speaker">Der Schloßpropst</span>. Ich habe mir nun
im Gegenteil sagen lassen, werter Graf, daß Herr Ulrich grade wegen
eines Heiratsprojekts aus Mailand hierher auf das Land geflohen und
erst in eine Art Tollheit verfallen ist!?</p>
<p class="calibre1"><span class="speaker">Graf Heinz</span>. Ihr werdet einen frisch
in die Falle gegangenen Wolf eher dazu bringen, daß er ein
lebendiges Osterlämmchen apportiert, als meinen originellen Vetter
Ulrich dazu, mit einer veritablen Braut unter Glockengeläut die
Schwelle der Kirchtür zu überschreiten.</p>
<p class="calibre1"><span class="speaker">Die Baronin</span>. Was in der Tat auch
Stoff für ein einziges großes Gelächter von Mailand bis Rom, von
Rom bis <a class="pcalibre3 pcalibre pcalibre1 pcalibre2" id="page14" title="joe_ebc/Pirki"></a>
Ravenna abgeben würde. Man müßte es, glaube ich, jenseit der Alpen
noch kichern hören.</p>
<p class="calibre1"><span class="speaker">Graf Eberhard</span>. Einerlei, seien wir
ernsthaft. Es stehen wichtige Dinge auf dem Spiel. Die Landstände
wollen sich nächstens versammeln. Ja, bereits heut werden sich etwa
zwanzig Vertrauensmänner zu einer Vorberatung hier einfinden. Man
rechnet mit dem Heimfall der Grafschaft. Und die Agnaten sind von
der niederträchtigsten Rührigkeit.</p>
<p class="calibre1"><span class="speaker">Der Schloßpropst</span>. Latet anguis
in herba<a class="pcalibre3 pcalibre pcalibre1 pcalibre2" href="#/Text/#annotation2" id="textAnno2"><sup class="calibre9">A2</sup></a>, jawohl.</p>
<p class="calibre1"><span class="speaker">Graf Eberhard</span>. Meines Erachtens
sollte er keine andere als die Contessa Pirani nehmen. Sie erbt auf
der Stelle fünf große Herrschaften. Ihr Herr Papa zieht ein
Rieseneinkommen aus zwölf oder vierzehn Häusern in Mailand, Rom,
Neapel und Genua. Sie ist vierzehn Jahr alt und gewachsen wie eine
Zypresse. Sie ist eigentlich über alle Begriffe schön.</p>
<p class="calibre1"><span class="speaker">Die Baronin</span>. Lieber Onkel, du
solltest jetzt gleich aus dem Stegreif deinem Panegyrikus ein
Sonett über ihre gefärbten Haare anheften!</p>
<p class="calibre1"><span class="speaker">Haushofmeister</span>. Soll es mir
gestattet sein, mitzuteilen, was Seine Erlaucht, unser Herr
Markgraf, über diesen durchlauchtigsten Engel zu bemerken geruht
haben?</p>
<p class="calibre1"><span class="speaker">Graf Eberhard</span>. Sprich.</p>
<p class="calibre1"><span class="speaker">Haushofmeister</span>. Wenn die Contessa
Pirani, wie Gott sie gemacht hat, sagte er, auf meinem
dunkelbraunen holländischen Bullen, den niemand zähmen kann, durch
das Dorf reiten, ihn dann an den Hörnern nehmen und an die Krippe
binden will, dann will ich sie vom Flecke weg heiraten.</p>
<p class="calibre1"><span class="speaker">Graf Eberhard</span>. Manchmal kommt mir
doch auch der Gedanke, ob nicht etwa doch, wie die Gegner annehmen,
der gute Neffe ein Fressen für die Medizinmänner der Sorbonne und
die Wärter des Spitales vom Grauen Kloster ist.</p>
<p class="calibre1"><span class="speaker">Haushofmeister</span>. Ich meine, er ist
nur Weiberfeind.</p>
<p class="calibre1"><span class="speaker">Die Baronin</span>, <span class="regie">nach allgemeinem Lachausbruch.</span> Da möchte ich Euch
doch wohl raten, Haushofmeister, wenn Ihr von einer irrigen Ansicht
abkommen wollt, seinen Spuren in den lombardischen Städten
nachzugehen: sein Weg ist mit blutigen Tränen verlassener und
betrogener Weiber bedeckt.</p>
<p class="calibre1"><span class="speaker">Graf Eberhard</span>. Gott weiß es, er hat
seinen einflußreichen Freunden die Vertuschung seiner wahnwitzigen
Aventiuren nicht immer leicht gemacht. <a class="pcalibre3 pcalibre pcalibre1 pcalibre2" id="page15" title="joe_ebc/Pirki"></a></p>
<p class="stage">Graf Ulrich tritt ein, wie ein Bauer gekleidet,
Lederhose, offenes Hemd, eine Heugabel über der Schulter.</p>
<p class="calibre1"><span class="speaker">Graf Ulrich</span>. Lieber Onkel, lieber
Vetter, liebe Cousine, was verschafft mir die Ehre?</p>
<p class="calibre1"><span class="speaker">Graf Eberhard</span>, <span class="regie">betroffen durch Ulrichs Aufzug.</span> Verzeih, lieber
Ulrich, wir wollten nicht stören.</p>
<p class="calibre1"><span class="speaker">Graf Ulrich</span>. Oh, es macht nichts,
ich habe nur der Jutta Dünger laden helfen.</p>
<p class="calibre1"><span class="speaker">Graf Eberhard</span>. Was hast du ihr
laden helfen?</p>
<p class="calibre1"><span class="speaker">Graf Ulrich</span>. Mist! – Du erlaubst,
teure Base . . . <span class="regie">Er lehnt das
landwirtschaftliche Werkzeug an die Wand.</span></p>
<p class="calibre1"><span class="speaker">Die Baronin</span>. Ihr habt Euch, wie es
scheint, seitdem Ihr auf dem Lande wohnt, einen neuen, nicht minder
penetranten Humor angeeignet, erlauchter Vetter, als weiland Eure
Stadthumore gewesen sind. Die Probe beweist es. Ihr habt Euch
gesteigert!</p>
<p class="calibre1"><span class="speaker">Graf Ulrich</span>. Ich habe mich in der
Tat gesteigert. Nicht um die Busentücher und Strumpfbänder der
zwölf schönsten Damen der Lombardei kehre ich in die Stadt
zurück.</p>
<p class="calibre1"><span class="speaker">Graf Eberhard</span>. Du warst allerdings
für das Feldlager immer besser geeignet als für den Terrazzo eines
Prunksaales. Allein, solche extremen Liebhabereien wie diese neuste
blieben mir bisher an dir unbekannt.</p>
<p class="calibre1"><span class="speaker">Graf Ulrich</span>. Was wünscht ihr von
mir?</p>
<p class="calibre1"><span class="speaker">Graf Eberhard</span>. Mein lieber
eigensinniger Neffe, erstlich haben wir zum soundsovielten Male
einen Familienrat gehalten . . .</p>
<p class="calibre1"><span class="speaker">Graf Ulrich</span>. Der wievielte ist
es?</p>
<p class="calibre1"><span class="speaker">Graf Heinz</span>. Der neunte Oktober.</p>
<p class="calibre1"><span class="speaker">Graf Ulrich</span>. Der wievielte
Familienrat, meinte ich. Ich glaube, der hundertundelfte wird es
sein. – Laß Wein und Gebäck bringen, Haushofmeister.</p>
<p class="stage">Der Haushofmeister ab.</p>
<p class="calibre1"><span class="speaker">Graf Eberhard</span>. Wenn es schon gleich
nicht der hundertundelfte Familienrat ist, so haben wir doch
allerdings in deiner wichtigen Sache wenigstens fünfmal umsonst
unsere Entschlüsse gefaßt. – Was hast du eigentlich gegen das
Heiraten?</p>
<p class="calibre1"><span class="speaker">Graf Ulrich</span>. Nicht das geringste,
solange ich keine Frau ins Haus zu nehmen brauche. Wenn ihr es
sonst wollt, will ich bei andrer Leute Hochzeit alle vier Wochen
Brautführer sein und alle vierzehn Tage Gevatter stehen. <a class="pcalibre3 pcalibre pcalibre1 pcalibre2" id="page16" title="joe_ebc/MEsswein"></a></p>
<p class="calibre1"><span class="speaker">Graf Eberhard</span>. Leider ist es mit
andrer Leute Hochzeit, lieber Neffe, eben ganz und gar nicht
getan.</p>
<p class="calibre1"><span class="speaker">Graf Ulrich</span>. Und mit meiner erst
recht nicht. Ich bin nicht so grausam, eine Frau zu nehmen! Meine
Frau – oder ich – täte mir leid.</p>
<p class="calibre1"><span class="speaker">Die Baronin</span>. Darin muß ich Euch
herzlich zustimmen.</p>
<p class="calibre1"><span class="speaker">Graf Eberhard</span>. Es hilft nichts, ich
muß dir jetzt nach der Schnur meine Vorschläge tun. Es kann dir
unmöglich beruhigend sein, deine Lehnsherrlichkeit von allen Seiten
gierig umlungert zu sehen. Mögen sie auch deine Lehnsfähigkeit
öffentlich vorderhand nicht antasten. Immerhin bist du unbeweibt,
und deine Deszendenz ist in Frage gestellt.</p>
<p class="calibre1"><span class="speaker">Graf Ulrich</span>. Nun, so bring mir
meinethalben alle die wohlriechenden Jungfrauen, die rohe Zwiebeln
essen, aber keine anderen, wenn ich absolut heiraten soll! Ihr
verlangt einen Thronerben, was mich wundernimmt, da ihr mich kennt:
denn ich schwöre euch, meine Kinder werden eher des Teufels als
stroherne Zierpuppen von Herzögen und Herzoginnen sein. Sie werden
dermaßen plebejische Neigungen haben, daß meine jetzigen euch
vorkommen werden, als sei ich aus Fruchtzucker und Rosenöl von
einem Konditor gebacken worden. Ich werde im ganzen Leben keinen
näselnden Grandseigneur, geschweige eine regierende Herzogin
zustande bringen, und wenn ich Gott weiß wie fein, zierlich und
wohlgewaschen zu Werke gehe.</p>
<p class="calibre1"><span class="speaker">Graf Eberhard</span>. Mein lieber Ulrich,
Gott erhalte dir deinen Humor! Deine unverwüstliche Konstitution
ist vollkommen hinreichende Bürgschaft für die edle Qualität deiner
Nachkommen. Dein Vater sagte auch starke Sachen, aber er hat es
doch immer eingesehen, daß man entweder in einem gewissen Sinne der
Sklave seiner Besitztümer ist oder aber ihr Herr auch nicht sein
kann. Du wirst auch, über kurz oder lang, tun, was die Stunde von
dir fordert.</p>
<p class="calibre1"><span class="speaker">Graf Ulrich</span>. Sag mal, seid ihr
gekommen, und versammeln sich diese Leute drinnen im Saal, um bei
meinem Fang Zeuge zu sein? Ich schwöre bei Gott, ihr täuscht euch
in mir, und ich werde das Recht meiner Herrschaft, solange ich
lebe, auch ohne Kunkel und Unterrock an meiner Seite zu wahren
wissen.</p>
<p class="calibre1"><span class="speaker">Graf Heinz</span>. Du hattest doch vor
Jahren einmal ein Auge auf die hübsche Tochter des Grafen Tankred
geworfen. <a class="pcalibre3 pcalibre pcalibre1 pcalibre2" id="page17" title="joe_ebc/MEsswein"></a></p>
<p class="calibre1"><span class="speaker">Graf Ulrich</span>. Sie wollte nicht
einmal über einen Zaun klettern, weil er oben mit einigen Scherben
gespickt war, als ich sie darum bat. Nicht einmal das wollte sie
tun, um mich ihrer Liebe zu versichern. Sie liebte mich nicht.</p>
<p class="calibre1"><span class="speaker">Graf Heinz</span>, <span class="regie">lachend.</span> Mensch, Markgraf, besinne dich! Wie kann
eine erlauchte Prinzessin aus regierendem Hause um irgend jemandes
willen über Zäune mit Scherben klettern?</p>
<p class="calibre1"><span class="speaker">Graf Ulrich</span>. Über wie viele Zäune
bin ich geklettert, wenn es nur eine Dienstmagd zu entjungfern
galt. Nein, nein! Mag sein, daß ihr recht habt! Und ich möchte auch
ganz gewiß niemand lieber als diesem verdammten Vasallen Tommaso
von Saluzza einen Streich spielen, der mir schon hinreichend lange
genug über den Zaun hereinschielen darf. Aber es geht mir ans
Leben!! – Sollte ich übrigens heiraten, so nehme ich höchstens eine
Bauernmagd, was man so sagt: einen Strunk! einen reellen,
wahrhaftigen Bissen Brot! Ein Mensch, das eine gute Tracht Prügel
aushält! Denn ein Weib, das keine gesunde Tracht Prügel vertragen
kann, macht den Reiter zum Pferd und das Pferd zum Reiter! – Da
schweigt ihr nun wieder! – Nun also, auf eine andere Weise geht es
nicht, und auf diese leider ebensowenig, sie verstößt gegen das
Hausgesetz.</p>
<p class="calibre1"><span class="speaker">Graf Heinz</span>. Hat nicht jüngst ein
Graf von Tirol die Tochter seines Waldhüters zur Ehe genommen?</p>
<p class="calibre1"><span class="speaker">Der Schloßpropst</span>. Mit kaiserlichem
Konsens, jawohl.</p>
<p class="calibre1"><span class="speaker">Graf Eberhard</span>. Nun, ich möchte fast
sagen, ehe du ohne Erben stirbst, versuch es mit was für einer du
willst: nur mache Kinder.</p>
<p class="calibre1"><span class="speaker">Graf Ulrich</span>. Was? – Lieber Onkel,
du solltest mit deinen Späßen behutsamer sein; solche Vorschläge
sollten dir nicht allzu lose sitzen. Wer weiß, ich verstehe am Ende
falsch, und unser Kaplan kriegt etwas zu kopulieren, wovon euch
Hören und Sehen vergeht. Hütet euch außerdem, daß ihr mir nicht,
wie einem Dachs oder Fuchs im Bau, jede Röhre verstopft und den
Ausweg abschneidet . . .</p>
<p class="stage">Diener bringen Wein und Gebäck herein.</p>
<p class="calibre1"><span class="speaker">Graf Eberhard</span>. Lieber Neffe, deine
Empfangsräume haben sich inzwischen mit treuen Vasallen und
Freunden – du kannst die Tritte und ihr Gemurmel hören! –
angefüllt. Sie hängen an dir! Sie setzen jede Hoffnung auf dich!
Sie haben einen geradezu verzweifelten Entschluß, dich – sagen wir,
glücklich zu machen, gefaßt. Glaub mir, du wirst <a class="pcalibre3 pcalibre pcalibre1 pcalibre2" id="page18" title="joe_ebc/MEsswein"></a> mit deinem ledigen
Stand unter ihnen den allerschwierigsten Stand haben.</p>
<p class="calibre1"><span class="speaker">Graf Ulrich</span> <span class="regie">stürzt ein Glas Wein hinunter.</span> Eine wie lange
Galgenfrist gebt ihr mir?</p>
<p class="calibre1"><span class="speaker">Graf Heinz</span>. Mir sollte es nicht
drauf ankommen, mich lieber heut als morgen in einer Schlinge
flutenden Mädchenhaars an einen der elfenbeinernen Galgen hängen zu
lassen, die du zur Auswahl hast!</p>
<p class="calibre1"><span class="speaker">Graf Eberhard</span>. Wir wollen sagen,
verpflichte dich auf ein Vierteljahr: drei Monate Brautschau, im
vierten Hochzeit.</p>
<p class="calibre1"><span class="speaker">Graf Ulrich</span> <span class="regie">stürzt ein zweites Glas Wein hinunter und wischt sich den
Schweiß von der Stirn.</span> Kann man sich nicht auf irgendeine
Weise, vielleicht durch Geld und gute Worte, um diese entsetzliche
Kalamität herumdrücken?</p>
<p class="calibre1"><span class="speaker">Die Baronin</span>, <span class="regie">nach herzlichem Lachen.</span> Man lernt doch mit einem
Manne Eures Schlages niemals recht aus. Zuweilen meint man, daß Ihr
Weiber zum Frühstück verspeist, zuweilen, daß Euch Weiber zum
Frühstück verspeisen wollen. Ich bin eine Frau: kein Wunder, wenn
mir der letzte Gedanke tröstlicher ist.</p>
<p class="calibre1"><span class="speaker">Graf Ulrich</span>. Baronin, ich glaube,
Ihr habt mir in diesem Augenblick einen nicht leicht zu
überschätzenden Dienst getan. Wenn es nun einmal ans Jagen geht,
will ich doch lieber Hund als Hase, lieber Habicht als Taube sein!
– Und jetzt wollen wir in die Versammlung der Götzendiener und
Knechte der Ehe eintreten.</p>
<p class="calibre1"><span class="speaker">Graf Eberhard</span>. Erlauchter Neffe,
nun, denke ich, darf man mit Fug auf deine Entscheidungen neugierig
sein.</p>
<p class="calibre1"><span class="speaker">Graf Ulrich</span>. Und eure Neugier soll
Futter erhalten! – Spracht Ihr nicht von einer Dreimonatsfrist? –
Nun, Ihr seht mich auf eine Weise gestiefelt und gespornt, daß Ihr
mich nicht einmal mehr durch eine Frist von nur drei Tagen in
Verlegenheit setzen könnt: zwei Tage Brautschau: am dritten mit
einem Kopfsprung ins Ehebett!</p>
<p class="calibre1"><span class="speaker">Graf Eberhard</span>. Das würde nach
Gestalt der Läufte in dieser an bösen Zungen so reichen Erdenwelt
bei jedem anderen als dir einen Sturm der Überraschung
hervorrufen.</p>
<p class="calibre1"><span class="speaker">Graf Ulrich</span>. Basta! Übermorgen ist
Hochzeit!</p>
<p class="calibre1"><span class="speaker">Graf Heinz</span>. Da hätten wir wohl Hals
über Kopf nichts weiter zu tun, als Gäste zu laden?</p>
<p class="calibre1"><span class="speaker">Graf Ulrich</span>. Tut das! – Trinkt! Und
wenn wir getrunken haben . . . <a class="pcalibre3 pcalibre pcalibre1 pcalibre2" id="page19" title="joe_ebc/MEsswein"></a></p>
<p class="calibre1"><span class="speaker">Die Baronin</span>. Ah! Dies
unvergleichliche, unerreichbare, göttliche Wundertier eines über
Wolken thronenden Weibes möchte ich sehen!</p>
<p class="calibre1"><span class="speaker">Graf Ulrich</span>. Aber kommt ihr nicht
zu nahe, Baronin . . .</p>
<p class="calibre1"><span class="speaker">Die Baronin</span>. Beißt sie und schlägt
sie?</p>
<p class="calibre1"><span class="speaker">Graf Ulrich</span>. Das könnte sein. –
Trinkt! – Auf keine Puppe mit einem Federhut! – Die schöne
Leibeigene! <span class="regie">Sie trinken.</span> Und nun wir
getrunken haben, das Glas an die Wand!</p>
<p class="stage">Die Gläser werden an die Wand geschleudert und
zerschellen. <a class="pcalibre3 pcalibre pcalibre1 pcalibre2" id="page20" title="joe_ebc/Sr"></a></p>
<ol class="calibre10"><li class="calibre11"><a class="pcalibre3 pcalibre pcalibre1 pcalibre2" href="#/Text/#textAnno2" id="annotation2">Latet anguis
in herba</a>: Die Schlange liegt im Gras versteckt</li>
</ol>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?338d4317